__turbopack_context__.v({
  "chip": "_6KJUvq_chip",
  "clickable": "_6KJUvq_clickable",
});
